export const SETTINGS_CATEGORY = {
    Beneficiaries: "beneficiaries",
    Titles: "titles",
    Contracts: "contracts",
    Sales: "sales",
    Compensations: "compensations",
    Statements: "statements",
    Payments: "payments",
    Enterprise: "enterprise",
} as const;

export type SettingsCategoryId = (typeof SETTINGS_CATEGORY)[keyof typeof SETTINGS_CATEGORY];

export type SettingsCategory = {
    id: SettingsCategoryId;
    title: string;
    description?: string;
};

/**
 * Ordered list of hidden settings sections.
 * Rendering order follows this array; keep related concerns adjacent.
 */
export const SETTINGS_CATEGORIES: readonly SettingsCategory[] = [
    {
        id: SETTINGS_CATEGORY.Beneficiaries,
        title: "Bénéficiaires",
        description: "Espace auteur, places, profils, notifications",
    },
    {
        id: SETTINGS_CATEGORY.Titles,
        title: "Titres",
        description: "Marques, métadonnées, devises, segmentation marché",
    },
    {
        id: SETTINGS_CATEGORY.Contracts,
        title: "Contrats",
        description: "Signature électronique, chaîne de validation, cessions",
    },
    {
        id: SETTINGS_CATEGORY.Sales,
        title: "Ventes",
        description: "Stock, prix de vente, distributeurs, abonnements",
    },
    {
        id: SETTINGS_CATEGORY.Compensations,
        title: "Compensations",
        description: "Compensations inter-canal, inter-terme, inter-titre",
    },
    {
        id: SETTINGS_CATEGORY.Statements,
        title: "Relevés",
        description: "Modèles de relevés, types de périodes, consolidation",
    },
    {
        id: SETTINGS_CATEGORY.Payments,
        title: "Paiements",
        description: "Paiements, virements internationaux, comptabilité, fiscalité",
    },
    {
        id: SETTINGS_CATEGORY.Enterprise,
        title: "Entreprise",
        description: "Sécurité, intégrations, analytics, outils développeur",
    },
] as const;
